const SLIDE_SELECTORS = ['.mmx-hero__product.mmx-hero__slide', '.mmx-hero__tagline.mmx-hero__slide', '.mmx-hero__content.mmx-hero__slide'];

class MmxHeroSlider extends HTMLElement {
  connectedCallback() {
    const dataEls = Array.from(this.querySelectorAll('.mmx-hero__slide-data'));
    this.indices = dataEls
      .map((el) => Number(el.dataset.slideIndex))
      .filter((n) => !Number.isNaN(n))
      .sort((a, b) => a - b);
    this.dataByIndex = new Map(dataEls.map((el) => [Number(el.dataset.slideIndex), el]));

    const controls = Array.from(this.querySelectorAll('.mmx-hero__controls'));

    if (this.indices.length <= 1) {
      controls.forEach((el) => {
        el.style.display = 'none';
      });
      if (this.indices.length === 1) this.activate(this.indices[0], { immediate: true });
      return;
    }

    this.current = this.indices[0];

    this.querySelectorAll('.mmx-hero__pagination').forEach((container) => {
      this.indices.forEach((index, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mmx-hero__pagination-dot';
        dot.dataset.slideIndex = String(index);
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => this.go(index));
        container.appendChild(dot);
      });
    });

    this.querySelectorAll('.mmx-hero__control--prev').forEach((btn) => {
      btn.addEventListener('click', () => this.step(-1));
    });
    this.querySelectorAll('.mmx-hero__control--next').forEach((btn) => {
      btn.addEventListener('click', () => this.step(1));
    });

    this.activate(this.current, { immediate: true });
  }

  step(direction) {
    const pos = this.indices.indexOf(this.current);
    const nextPos = ((pos + direction) % this.indices.length + this.indices.length) % this.indices.length;
    this.go(this.indices[nextPos]);
  }

  go(index) {
    if (index === this.current) return;
    this.current = index;
    this.activate(index, { immediate: false });
  }

  activate(index, { immediate }) {
    SLIDE_SELECTORS.forEach((selector) => {
      this.querySelectorAll(selector).forEach((el) => {
        el.classList.toggle('is-active', Number(el.dataset.slideIndex) === index);
      });
    });

    this.syncVideos(index);

    this.querySelectorAll('.mmx-hero__pagination-dot').forEach((dot) => {
      dot.classList.toggle('is-active', Number(dot.dataset.slideIndex) === index);
    });

    const accentText = this.dataByIndex.get(index)?.dataset.headingAccent || '';
    const accentEls = this.querySelectorAll('.mmx-hero__heading-accent-inner:not([data-fixed])');
    if (immediate) {
      accentEls.forEach((el) => {
        el.textContent = accentText;
      });
      return;
    }
    accentEls.forEach((el) => {
      el.classList.add('is-leaving');
      window.setTimeout(() => {
        el.textContent = accentText;
        el.classList.remove('is-leaving');
        el.classList.add('is-entering');
        void el.offsetWidth;
        el.classList.remove('is-entering');
      }, 350);
    });
  }

  // Only the active slide's video plays; outgoing ones just pause so their fade-out doesn't jump.
  // <alpha-video> slides pick their own file, lazy-load and handle reduced motion; they only need
  // to know whether they're active.
  syncVideos(index) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.querySelectorAll('.mmx-hero__product.mmx-hero__slide').forEach((slide) => {
      const isActive = Number(slide.dataset.slideIndex) === index;
      const alphaVideo = slide.querySelector('alpha-video');
      if (alphaVideo) {
        alphaVideo.toggleAttribute('data-active', isActive);
        return;
      }
      const video = slide.querySelector('.mmx-hero__video');
      if (!video) return;
      if (isActive && !reduceMotion) {
        video.preload = 'auto';
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }
}

if (!customElements.get('mmx-hero-slider')) {
  customElements.define('mmx-hero-slider', MmxHeroSlider);
}
